import { useState, useEffect } from "react"
import { useNavigate, useParams } from "react-router-dom"
import { toast } from "react-toastify"

// import { getSingleCategories, updateSingleCategories } from "../../assets/api/super-admin"
import Layout from "../../layouts/layout"
import MainPageLayout from "../../components/main-page-layout/mainPageLayout"
import { useRequestProcessor } from "../../api/requestProcessor"
import { getAllCategories, getSingleCategory, updateSingleCategories } from "../../api/categories"
import Loading from "../../components/loading/loading"



import Select from "react-select";
import makeAnimated from 'react-select/animated';


const EditCategories = () => {

    const { Query, Mutate } = useRequestProcessor();

    const { category_id } = useParams()



    const { data: fetchedData, isLoading, isError } = Query(
        ['getSingleCategory', category_id],
        () => getSingleCategory(category_id)
    );

    const [name, setName] = useState("")
    const [selectedCategories, setSelectedCategories] = useState([])

    const navigate = useNavigate();



    const { data: categoriesData, } = Query(
        ['getAllUsersWithoutPaginate'],
        () => getAllCategories("all"),
    )

    const { mutate } = Mutate(
        "updateSingleCategory",
        updateSingleCategories,
        {
            onSuccess: (data) => {
                successfulHandler(data) //This is the response you get back
            }
            ,
            onError: (data) => {
                toast.error(data.response.data.message)
            }
        }
    );

    function setData (data){
        setName(data?.title)
        data?.parent && setSelectedCategories([{label:data?.parent?.title ,value:data?.parent?.id  , } ])
    }


    useEffect(()=>{
        setData(fetchedData?.data)
    },[fetchedData])

    function successfulHandler(res) {
        toast.success(res.message, {
            progress: false,
            autoClose: 2200,
        })
        toast.info("تا چند ثانیه دیگر به صفحه اصلی منتقل میشوید", {
            autoClose: 2500,
            pauseOnHover: false
        })
        setTimeout(() => { navigate("/admin/categories") }, 3000)
    }


    async function onSubmitHandler(e) {
        e.preventDefault();
        let data = {
            category_id:category_id,
            title: name,
            parent_id: selectedCategories.length ? selectedCategories[0].value : null
        }
        mutate(data)
    }

    const animatedComponents = makeAnimated();
    function handleOnChangeWorkshop(data) {
        setSelectedCategories(data)
    }


    // add default from api
    return (
        <Layout >
            {!isLoading &&
                <MainPageLayout backButton sectionTitle={"ویرایش دسته بندی " + name + " :"} title={"ویرایش دسته بندی"} >

                    <form onSubmit={onSubmitHandler}>
                        <div className='flex  my-4'>
                            <div className='flex flex-col my-3 w-full'>
                                <p className='pr-3 pb-1'>نام دسته بندی :</p>
                                <input type="text" value={name} onChange={(e) => setName(e.target.value)} className='!w-full form-input' placeholder='نام دسته بندی' />
                            </div>
                            <div className='flex flex-col my-3 w-full mr-4'>
                                <p className='pr-3 pb-1'>انتخاب دسته بندی والد :</p>
                                <Select components={animatedComponents} placeholder="انتخاب کنید..." styles={{ zIndex: "-1" }}
                                    onChange={handleOnChangeWorkshop} closeMenuOnSelect={false} value={selectedCategories} isMulti isOptionDisabled={() => selectedCategories.length >= 1}
                                    options={categoriesData?.data?.map(el => ({ label: el.title, value: el.id }))}
                                />
                            </div>
                        </div>
                        <div id='form-add-button--container'>
                            <button type="submit" id='form-add-button'>ثبت</button>
                        </div>
                    </form>
                </MainPageLayout>
            }
            {
                isLoading && <Loading />
            }
        </Layout>
    )
}

export default EditCategories